export const date = value => {
  const dateObj = new Date(value)
  const day = `0${dateObj.getDate()}`.substr(-2)
  const month = `0${dateObj.getMonth() + 1}`.substr(-2)
  const year = dateObj.getFullYear()
  const formattedDob = `${day}/${month}/${year}`
  return formattedDob
}

export const currency = (value, noDecimal) => {
  // let formattedCurrency = parseInt(Intl.NumberFormat().format(value))
  // formattedCurrency = `RM ${formattedCurrency.toFixed(2)}`
  try {
    const result = noDecimal ? `RM${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace('.00', '')}`
      : `RM${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
    return result
  } catch(e) {
    // console.log(e)
    return noDecimal ? "RM0" : "RM0.00"
  }
}

export default {
  date,
  currency
}